export const store_setting = [
    {
        sub_domain:"",
        delivery_type:["E-CARD","MAIL"]
    },
    {
        sub_domain:"glwd",
        delivery_type:["E-CARD","MAIL"]
    },
    {
        sub_domain:"cityharvest",
        delivery_type:["E-CARD","MAIL"]
    }
]